require('./RAComparativeTable.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

// @commons
const { Accordion } = require('commonsComponents/accordion');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { AccordionBody } = require('commonsComponents/accordionBody');

// @utilities
const { formatPercentage } = require('../../utilities/RACurrencyHelper');

// @constants
const {
    ACTIVE_CLASS_MONEY_MARKET_ID,
    ACTIVE_CLASS_FIXED_INCOME_ID,
    ACTIVE_CLASS_EQUITY_ID,
    ACTIVE_CLASS_REAL_ASSETS_ID,
} = require('../../raConstants/index');

class RAComparativeTable extends React.Component {
    constructor(props) {
        super(props);

        this.handleToggle = this.handleToggle.bind(this);
        this.state = {};
    }

    handleToggle(value, id) {
        this.setState({ [id]: value });
    }

    getAccordionClassName(assetClassId) {
        const customClass = classnames('ra-comparative-table__wrapper', {
            'ra-comparative-table__wrapper--money-market':
                assetClassId === ACTIVE_CLASS_MONEY_MARKET_ID,
            'ra-comparative-table__wrapper--fixed-income':
                assetClassId === ACTIVE_CLASS_FIXED_INCOME_ID,
            'ra-comparative-table__wrapper--equity':
                assetClassId === ACTIVE_CLASS_EQUITY_ID,
            'ra-comparative-table__wrapper--real-assets':
                assetClassId === ACTIVE_CLASS_REAL_ASSETS_ID,
        });

        return customClass;
    }

    getAccordionTitleClassName(isExpanded) {
        const customClass = classnames('ra-comparative-table__primary-text', {
            'ra-comparative-table__primary-text--bold': isExpanded,
        });

        return customClass;
    }

    buildSubAssetClassesGrid(immSubAssetClasses) {
        const grid = immSubAssetClasses.valueSeq().map(immSubAssetClass => (
            <table
                className="ra-comparative-table__grid"
                key={immSubAssetClass.get('subAssetClass')}
            >
                <tbody>
                    <tr>
                        <td className="ra-comparative-table__grid-cell--first">
                            <span className="ra-comparative-table__primary-text">
                                {immSubAssetClass.get('subAssetClass')}
                            </span>
                        </td>
                        <td className="ra-comparative-table__grid-cell--middle">
                            <span className="ra-comparative-table__primary-text">
                                {formatPercentage(
                                    immSubAssetClass.get('originWeight'),
                                )}
                            </span>
                        </td>
                        <td className="ra-comparative-table__grid-cell--last">
                            <span className="ra-comparative-table__primary-text">
                                {formatPercentage(
                                    immSubAssetClass.get('newWeight'),
                                )}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        ));

        return grid;
    }

    buildComparativeTable(immComparative) {
        const table = immComparative.entrySeq().map(immAssetAllocation => {
            const immAsset = immAssetAllocation[1];
            const assetId = immAssetAllocation[0];
            const immSubAssetClasses = immAsset.get('subAssetClasses');
            const wrapperClassName = this.getAccordionClassName(assetId);
            const accordionTitleClassName = this.getAccordionTitleClassName(
                this.state[assetId],
            );
            const subAssetClassesGrid = this.buildSubAssetClassesGrid(
                immSubAssetClasses,
            );

            return (
                <div className={wrapperClassName} key={assetId}>
                    <Accordion
                        customClassName="ra-comparative-table__accordion"
                        id={assetId}
                        key={assetId}
                        onClick={this.handleToggle}
                    >
                        <AccordionHeader name="AccordionHeader">
                            <div className="ra-comparative-table__header-content">
                                <div className="ra-comparative-table__header-col ra-comparative-table__header-col--first">
                                    <span className={accordionTitleClassName}>
                                        {immAsset.get('assetClass')}
                                    </span>
                                    <span className="ra-comparative-table__header-content-secondary">
                                        ({immSubAssetClasses.size})
                                    </span>
                                </div>
                                <div className="ra-comparative-table__header-col ra-comparative-table__header-col--middle">
                                    <span className="ra-comparative-table__primary-text ra-comparative-table__primary-text--bold">
                                        {formatPercentage(
                                            immAsset.get('originWeight'),
                                        )}
                                    </span>
                                </div>
                                <div className="ra-comparative-table__header-col ra-comparative-table__header-col--last">
                                    <span className="ra-comparative-table__primary-text ra-comparative-table__primary-text--bold">
                                        {formatPercentage(
                                            immAsset.get('newWeight'),
                                        )}
                                    </span>
                                </div>
                            </div>
                        </AccordionHeader>
                        <AccordionBody name="AccordionBody">
                            <div className="ra-comparative-table__accordion-body">
                                {subAssetClassesGrid}
                            </div>
                        </AccordionBody>
                    </Accordion>
                </div>
            );
        });

        return table;
    }

    render() {
        const { immComparative } = this.props;
        const comparativeTable = immComparative
            ? this.buildComparativeTable(immComparative)
            : null;

        return <div className="ra-comparative-table">{comparativeTable}</div>;
    }
}

RAComparativeTable.propTypes = {
    immComparative: PropTypes.object.isRequired,
};

module.exports = RAComparativeTable;
